import { ApiClient, type TokenStore } from '@app/shared/client';

/**
 * The single ApiClient instance for the web app. It wraps `fetch`, injects the
 * bearer token from localStorage, and unwraps the `{ data, meta }` envelope — every
 * screen consumes it through TanStack Query hooks (never `useEffect` + `fetch`).
 *
 * Same-origin base URL: the Express server serves the built bundle and the `/api`
 * routes from one process (§3.1); in dev, Vite proxies `/api` to the server.
 */

const TOKEN_KEY = 'ehe.token';

const localStorageTokenStore: TokenStore = {
  get: () => {
    try {
      return localStorage.getItem(TOKEN_KEY);
    } catch {
      return null;
    }
  },
  set: (token) => {
    try {
      if (token) localStorage.setItem(TOKEN_KEY, token);
      else localStorage.removeItem(TOKEN_KEY);
    } catch {
      /* private mode / disabled storage — token stays in memory only */
    }
  },
};

export const api = new ApiClient({ baseUrl: '', tokenStore: localStorageTokenStore });

export { ApiError } from '@app/shared/client';
